import React from 'react';
import PresentationTitle from '../components/presentationTitle';

const data = {
  title: 'Honoraires',
  text: `Les honoraires du cabinet sont déterminés en fonction de la complexité de l’affaire et donnent lieu avant toute démarche, à la signature d’une convention d’honoraires entre l’avocat et le client.
  
  L’humanité étant un des piliers du serment prêté à l’entrée dans la profession, la prise en charge des dossiers est favorisée au maximum et peut donner lieu à des modalités de paiement différé afin de ne pas dissuader les requérants de défendre leurs droits.
  
  Le cabinet accepte les procédures prises en charge au titre des protections juridiques ainsi qu’à l’aide juridictionnelle, qu’elle soit totale ou partielle.
  
  L’admission du client à l’aide juridictionnelle partielle donne lieu à un complément d’horaires en fonction du pourcentage obtenu. Ce dernier est déterminé librement entre l’avocat et son client mais tient compte de la situation financière de ce dernier.
  
  Le cabinet propose également des conventions d’honoraires avec honoraires de résultat, notamment en ce qui concerne les procédures en responsabilité, qu’elles soient médicales ou non. Ces dernières permettent au client d’avancer des frais limités qui seront compensés à l’issue de la procédure en fonction du résultat obtenu.
  
  Le premier rendez-vous au cabinet est facturé à hauteur de 100 euros HT.
  
  Ce dernier ne donne pas lieu à facturation dans le cadre de l’engagement d’une procédure au titre de laquelle il sera compris.`,
};

const Honoraires = () => {
  const { title, text } = data;

  return <PresentationTitle title={title} text={text} />;
};

export default Honoraires;



// WEBPACK FOOTER //
// ./src/app/pages/honoraires.jsx